<template>
    <div class="index-1-left-1">
        <div @click="clickKa()">
            <div class="index-title" style="display: flex;">
                <img src="/img/home/parkinfo.png" alt="" style="width: 20px;height: 20px;margin-right: 5px;">
                <span>园区信息</span>
            </div>
        </div>
        <el-row :gutter="80" style="padding: 10px">
            <el-col :span="6" v-for="(item, index) in stats" :key="index">
                <div style="display: flex;align-items: center;">
                    <img :src="list[index].src" alt="" style="width: 50px;height: 50px;">
                    <div style="display: grid;margin-top: -4px;text-align: left;margin-left: 10px;">
                        <div style="font-size: 28px;font-weight: 700;">{{ indexCommunityViewInfo[item.key] }}</div>
                        <span style="font-size: 12px;margin-top: 0px;">{{ list[index].label }}</span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="padding: 10px;margin-bottom: 20px;margin-top: 20px;">
            <el-col :span="12" v-for="(item, index) in listb" :key="index">
                <div
                    style="display: flex;align-items: center;border: 1px solid rgba(0, 0, 0, 0.1);border-radius: 8px;padding: 20px 15px;justify-content: space-between;">
                    <div style="display: flex;">
                        <img :src="item.src" alt="" style="width: 50px;height: 50px;">
                        <div style="display: grid;margin-top: -4px;text-align: left;margin-left: 10px;">
                            <div style="font-size: 28px;font-weight: 700;">
                                {{ index === 0 ? indexCommunityViewInfo.ownerCount : indexCommunityViewInfo.carCount }}
                            </div>
                            <span style="font-size: 12px;margin-top: 0px;">{{ item.label }}</span>
                        </div>
                    </div>
                    <div @click="clickIndex(index)"
                         style="width: 80px;height: 27px;background: rgb(64,72,101);border-radius: 20px;line-height: 27px;color: white;font-size: 14px;">
                        {{ index === 0 ? '登记住户' : '查看车辆' }}
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {getPropertyAssetsIndex} from '@/api/index/propertyIndexApi'

export default {
    name: 'IndexCommunity',
    data() {
        return {
            list: [{
                'label': '楼层',
                'money': '1123',
                'src': "/img/home/louceng.png",
            }, {
                'label': '商铺',
                'money': '2456',
                'src': "/img/home/shangpu.png",
            }, {
                'label': '办公室',
                'money': '3789',
                'src': "/img/home/bangongshi.png",
            }, {
                'label': '公寓',
                'money': '46666',
                'src': "/img/home/gongyu.png",
            }],
            listb: [{
                'label': '住户登记',
                'money': '1123',
                'src': "/img/home/dengji.png",
            }, {
                'label': '车辆',
                'money': '2456',
                'src': "/img/home/cheliang.png",
            }],
            indexCommunityViewInfo: {
                floorCount: 0,
                roomCount: 0,
                shopCount: 0,
                ownerCount: 0,
                spaceCount: 0,
                carCount: 0,
            },
            stats: [
                {key: 'floorCount', label: 'building', icon: 'el-icon-office-building'},
                {key: 'roomCount', label: 'house', icon: 'el-icon-house'},
                {key: 'shopCount', label: 'shop', icon: 'el-icon-shopping-bag-2'},
                {key: 'spaceCount', label: 'parkingSpace', icon: 'el-icon-truck'}
            ]
        }
    },
    created() {
    },
    methods: {
        _loadPropertyIndexAssets() {
            const param = {
                page: 1,
                row: 10,
                communityId: this.getCommunityId()
            }

            getPropertyAssetsIndex(param)
                .then(res => {
                    if (res.code === 0) {
                        Object.assign(this.indexCommunityViewInfo, res.data)
                    }
                })
                .catch(err => {
                    console.error('请求失败处理', err)
                })
        },
        clickKa() {
            this.$router.push('/pages/property/room')
        },
        clickIndex(index) {
            if (index === 0) {
                this.$router.push('/pages/property/listOwner?tab=ownerInfo')
            } else {
                this.$router.push('/pages/property/listOwnerCar?tab=ownerCar')
            }
        },
        _toOwner() {
            this.$router.push('/pages/property/listOwner?tab=ownerInfo')
        },
        _toCar() {
            this.$router.push('/pages/property/listOwnerCar?tab=ownerCar')
        }
    }
}
</script>

<style lang="scss" scoped>

.index-1-left-1 {
    border: 1px solid rgba(179, 186, 222, 1);
    background-image: url(/img/home/img_cardbg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 10px;
    padding: 15px;

    .index-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
        text-align: left;
        color: #333;
    }

    .index-1-left-1-content {
        padding: 50px 0;
        border-bottom: 1px solid #eee;

        > div {
            width: 25%;
            text-align: center;
        }

        .index-1-left-img {
            width: 40px;
            height: 40px;
            background: #f0f7ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            i {
                font-size: 20px;
                color: #409EFF;
            }
        }

        .index-number {
            font-size: 24px;
            font-weight: bold;
            color: #333;
        }

        .index-number-describe {
            font-size: 12px;
            color: #999;
        }
    }

    .index-1-left-1-bottom {
        padding: 28px 40px;

        .index-1-left-1-bottom-item {
            width: 40%;
            border-radius: 4px;
            padding: 10px;
            padding-left: 30px;
            padding-right: 30px;

            .index-name {
                font-size: 16px;
                font-weight: bold;
                color: #333;
            }

            .index-name-ico {
                width: 40px;
                height: 40px;
                background: #e6f7ff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 10px auto;

                i {
                    font-size: 20px;
                    color: #1890ff;
                }
            }

            .index-number {
                font-size: 24px;
                font-weight: bold;
                color: #333;

                .index-number-unit {
                    font-size: 14px;
                    color: #999;
                }
            }

            .index-number-describe {
                font-size: 12px;
                color: #1890ff;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .margin-top-sm {
        margin-top: 5px;
    }
}
</style>
